import React, { useEffect } from "react";
import { AdsGETApiAuth } from "../../../../Constant/api";
import { slugs } from "../../../../Constant/slugs";

export default function EmployeeModal(props) {
  const {
    setEmployeeID,
    setEmployeeName,
    setEmployeeSlug,
    EmployeeID,
    setEmployeeModal,
    EmployeesList,
  } = props;
  const [reload, setReload] = React.useState(false)
  const [serachName, setSearchName] = React.useState("")
  const [serachEmail, setSearchEmail] = React.useState("")
  const [serachPhone, setSearchPhone] = React.useState("")
  const [Projects1, setProjects1] = React.useState(EmployeesList)

  return (
    <div>
      <div className="row">
        <div style={{ width: "10px" }} />
        <input className="col-3" style={{ margin: "1px 2px", padding: "3px 2px" }}
          value={serachName} placeholder="Employee Name"
          onChange={(event) => {
            setSearchName(event.target.value)
            setProjects1(EmployeesList.filter(a => a.meta.user_name.toLowerCase().includes(event.target.value.toLowerCase())))
          }}
        />
        <input className="col-4" style={{ margin: "1px 2px", padding: "3px 2px" }}
          value={serachEmail} placeholder="Employee Email"
          onChange={(event) => {
            setSearchEmail(event.target.value)
            setProjects1(EmployeesList.filter(a => a.meta.user_email.toLowerCase().includes(event.target.value.toLowerCase())))
          }}
        />
        <input className="col-3" style={{ margin: "1px 2px", padding: "3px 2px" }}
          value={serachPhone} placeholder="Employee Phone Number"
          onChange={(event) => {
            setSearchPhone(event.target.value)
            setProjects1(EmployeesList.filter(a => a.meta.user_phone_number.toLowerCase().includes(event.target.value.toLowerCase())))
          }}
        />
      </div>
      <table>
        <tbody>
          <tr>
            <td colSpan={6}
              onClick={() => {
                // setEmployeeID("")
                // setEmployeeEmail("")
                // setEmployeePhoneNumber("")
                // setEmployeeUserName("")
                setEmployeeModal(false)
                setEmployeeID("")
                setEmployeeName("")
                setEmployeeSlug("")
              }}>
              Clear
            </td>
          </tr>
          {Projects1.map((item, index) => (
            <tr key={index}
              onClick={() => {
                // setEmployeeID(item.meta.user_id)
                // setEmployeePhoneNumber(item.meta.user_phone_number)
                // setEmployeeEmail(item.meta.user_email)
                // setEmployeeUserName(item.meta.user_name)
                // setEmployeeModal(false)
                setEmployeeID(item.id)
                setEmployeeName(item.meta.name)
                setEmployeeSlug(item.slug)
                setEmployeeModal(false)
              }}
            >
              <>
              {/* {JSON.stringify(Projects1)} */}
                <td>
                  {item.id == EmployeeID ?
                    <i className="fa fa-check-square-o" />
                    :
                    <i className="fa fa-square-o" />
                  }
                </td>
                {/* <td>{item.id}</td> */}
                <td>{item.meta.roll_no}</td>
                <td>{item.meta.phone}</td>
                <td>{item.meta.name}</td>
                <td>{item.meta.email}</td>
                <td style={{ cursor: "pointer" }}

                >Choose</td>
              </>

            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}